module.exports = __webpack_public_path__ + "e74cee8c85e5a209379839c9fa5aaf18.MP3";